/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $modal from './_modal'

var ownerId: number = 0
var pageName: string = null
var pagePrefix: string = null

export function init($pageName, $pagePrefix, $ownerId, $propertiesCount): void {
    pageName = $pageName
    pagePrefix = $pagePrefix
    ownerId = $ownerId

    console.log('properties links: ' + $('.' + pagePrefix + '-properties a').length)

    $('.' + pagePrefix + '-properties a').click(function (e) {
        console.log('property link click')
        $modal.load($(this).attr('data-link'), {}, false, true, true)
        e.preventDefault()
    })

    $('.' + pagePrefix + '-property-count').html($propertiesCount + ' st')
}
